import React, { useState, useEffect } from "react";
import { useLocation, Link } from 'react-router-dom';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import { Layout, Breadcrumb, Avatar, Spin } from 'antd';
import axios from 'axios';
import { CalendarOutlined, HomeOutlined, UserOutlined } from '@ant-design/icons';

interface NotificationDetails {
    notificationid:string;
    notificationtype:string;
    messagetext:string;
    notificationdate: Date;
    ecardimage:string;
    nominatorname:string;
    awardname:string;
    nominatorimage:string;
};

const ViewNotification: React.FC = () => {
  const location = useLocation();
  const { notificationId, notificationType } = location.state || {};
  const { instance, accounts } = useMsal();
  const [notificationData, setNotificationData] = useState<NotificationDetails[]>([]);
  const [loading, setLoading] = useState(true);

  const baseURL = process.env.REACT_APP_API_URL;
  const userId = localStorage.getItem("UserId");

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const token = await fetchToken();

        if (notificationType !== "All") {
          const response = await axios.get(`${baseURL}/api/UserNotification/GetUserNotificationsById`, {
            params: {
              notification_id: notificationId,
              notification_type: notificationType
            },
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          if (response.status === 200) {
            setNotificationData([...response.data].sort((a: NotificationDetails, b: NotificationDetails) =>
  new Date(b.notificationdate).getTime() - new Date(a.notificationdate).getTime()
));
          }
        } else {
          const response = await axios.get(`${baseURL}/api/UserNotification/GetAllUserNotifications/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          if (response.status === 200) {
            setNotificationData([...response.data].sort((a: NotificationDetails, b: NotificationDetails) =>
  new Date(b.notificationdate).getTime() - new Date(a.notificationdate).getTime()
));
          }
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, [notificationId, notificationType]);

  return (
    <Layout style={{ background: '#F9FAFB' }}>
      <AppHeaderHomePageTemplate />
        <div style={{
            maxWidth: '100%',
            margin: '0 auto',
            padding: '0px',
            backgroundColor: '#',
            minHeight: '100vh',
            width: '50rem'
            }}>
        <Breadcrumb
                style={{
                    backgroundColor: 'white',
                    padding: '20px 20px 10px',
                }}>
            <Breadcrumb.Item>
                <Link to="/home">
                    <HomeOutlined style={{ marginRight: '5px' }} />
                    Home
                </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Notifications</Breadcrumb.Item>
        </Breadcrumb>
            <div style={{backgroundColor: 'white', font:'roboto'}}>
        <div style={{ padding: '20px' }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
              <Spin size="large" tip="Loading notifications..." />
            </div>
          ) : notificationData.length > 0 ? (
            notificationData.map((item) => (
          <div
            key={item.notificationid}
            style={{
              marginBottom: '20px',
              padding: '10px',
              border: '1px solid #E0E0E0',
              borderRadius: '5px',
              backgroundColor: '#F9FAFB',
            }}>
            <div style={{ display: 'flex', alignItems: 'left' }}>
                <span>
                    <Avatar src={item.nominatorimage ? `data:image/jpeg;base64,${item.nominatorimage}` : undefined} size={40} icon={!item.nominatorimage && <UserOutlined />} />
                </span>
                <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000', textAlign: 'left', display: 'block', marginLeft: '10px' }}>
                {item.notificationtype === "Appreciation" && (
                    <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000' }}>
                       <strong>{item.nominatorname}</strong> appreciates you for demonstrating <strong>{item.awardname}</strong>.
                    </span>
                )}
                {item.notificationtype === "Celebration" && (
                    <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000' }}>
                        <strong>{item.nominatorname}</strong> wishes you for <strong>{item.awardname}</strong>.
                    </span>
                )}
                {item.notificationtype === "Nomination" && (
                    <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000' }}>
                        You have received <strong>{item.awardname}</strong> from <strong>{item.nominatorname}</strong>.
                    </span>
                )}
                {item.notificationtype === "Points" && (
                    <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000' }}>
                        You have been awarded <strong>{item.awardname}</strong>
                        {item.nominatorname ? <> by <strong>{item.nominatorname}</strong></> : ''}.
                    </span>
                )}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left' }}>
              <span style={{ fontWeight: '400', fontSize: '16px', color: '#000000' }}>
                {item.messagetext}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px', color: '#888888', marginTop: '5px' }}>
                <CalendarOutlined style={{ color: '#888888',marginRight:'5px' }} />
                {new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                }).format(new Date(item.notificationdate))}
              </div>
            {item.ecardimage && (
              <div style={{ marginTop: '10px', fontSize: '14px', color: '#555555' }}>
                <img src={`data:image/jpeg;base64,${item.ecardimage}`} alt="eCard" style={{ width: '100%', objectFit: 'contain', borderRadius: '8px', marginBottom: '10px' }} />
              </div>
            )}
          </div>
        ))
      ) : (
        <p style={{ fontSize: '16px', color: '#888888' }}>No notifications available.</p>
      )}
    </div>
            </div>

        </div>

    </Layout>
  );
};

export default ViewNotification;
